import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { SmallHeaderComponent } from '../../shared/partials/small-header/small-header.component';
import { DestinationsService } from '../../reducers/services/destinations.service';
import { SectionTitleComponent } from '../../shared/components/ui-elements/section-title/section-title.component';
import { TabComponent } from '../../shared/components/tab/tab.component';
import { DiningsCardCarouselComponent } from '../dinings-card-carousel/dinings-card-carousel.component';

@Component({
  selector: 'app-dinings-page',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    SmallHeaderComponent,
    SectionTitleComponent,
    TabComponent,
    DiningsCardCarouselComponent,
  ],
  templateUrl: './dinings-page.component.html',
  styleUrl: './dinings-page.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DiningsPageComponent {
  latestDinings: any[] = [];
  isTocExpanded = false;
  totalCount: number = 0;
  slug: string = '';
  page = 1;
  limit = 9;
  blogContainerId = 'blog-search-container';
  query = '';
  upcominghotels: any[] = [];
  tabs: any[] = [];
  filteredDinings: any[] = [];
  private platformId = inject(PLATFORM_ID);
  destinations: any[] = [];
  loading = false;
  selectedDestinationId: string | null = null;
  destinationsLoaded = false;
  diningsLoaded = false;
  selectedIndex: number = 0;
  @Input() data: any;

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
    private route: ActivatedRoute,
    private destinationService: DestinationsService
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.scrollToTop();
      this.getDestinations();
      this.fetchDiningsList();

      this.route.paramMap.subscribe((params) => {
        this.selectedDestinationId = params.get('slug') || null;
        this.trySelectTabFromQuery();
      });

    }
  }

  scrollToTop() {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  fetchDiningsList(): void {
    this.destinationService.getDiningList().subscribe(
      (res: any) => {
        this.latestDinings = res?.data || [];
        this.totalCount = res?.totalCount || 0;
        this.diningsLoaded = true;
        this.trySelectTabFromQuery();
      },
      (err) => {
        console.error('fetchDiningsList error', err);
        this.diningsLoaded = true;
        this.trySelectTabFromQuery();
      }
    );
  }

  private trySelectTabFromQuery(): void {
    if (!this.destinationsLoaded || !this.diningsLoaded || !this.tabs?.length) {
      return;
    }

    let indexToSelect = 0;
    if (this.selectedDestinationId) {
      const idx = this.tabs.findIndex(
        (t) => String(t.slug) === String(this.selectedDestinationId)
      );
      if (idx >= 0) indexToSelect = idx;
    }

    this.selectedIndex = indexToSelect;
    this.onTabChange(indexToSelect, true);
  }

  getDestinations(): void {
  this.loading = true;
  this.destinationService.getDestinationDropDown({ country: 'India' }).subscribe({
    next: (res: any) => {
      this.destinations = res?.data || [];
      this.loading = false;

      const totalRestaurantCount =
        res?.totalRestaurantCount ??
        res?.totalDiningCount ??
        this.destinations.reduce(
          (sum: number, d: any) => sum + (d.restaurantCount ?? 0),
          0
        );

      this.tabs = [
        { label: 'All', id: 'all', target: '#all', badgeCount: totalRestaurantCount }, // ✅
        ...this.destinations.map((d: any) => ({
          label: d.name,
          id: d._id,
          slug: d.slug,
          target: `#${d.slug}-section`,
          badgeCount: d.restaurantCount ?? 0,
        })),
      ];

      this.destinationsLoaded = true;
      this.trySelectTabFromQuery();
    },
    error: () => {
      this.loading = false;
      this.destinationsLoaded = true;
      this.trySelectTabFromQuery();
    },
  });
}


  onTabChange(index: number, skipNavigate = false) {
    if (!this.tabs || this.tabs.length === 0) return;
    const selectedTab = this.tabs[index];
    if (!selectedTab) return;

    this.selectedDestinationId = selectedTab.id;
    this.selectedIndex = index;

    if (!skipNavigate) {
      if (selectedTab.slug) {
        this.router.navigate(['/restaurant', selectedTab.slug]);
      } else {
        this.router.navigate(['/restaurant']);
      }
    }

    if (selectedTab.id === 'all') {
      this.filteredDinings = [...this.latestDinings];
    } else {
      this.filteredDinings = this.latestDinings.filter((d: any) => {
        const destId = d?.destination?._id;
        return String(destId) === String(selectedTab.id);
      });
    }
  }
}
